<section class="mobile-navbar-dialog-content" aria-labelledby="mobile-notifications-title">
  <header class="mobile-navbar-dialog-header">
    <h2 id="mobile-notifications-title">Notificações</h2>
    <div class="mobile-notifications-header-actions">
      <button type="button" mat-icon-button aria-label="Marcar todas como lidas" (click)="markAllAsRead()">
        <i class="fa-solid fa-check-double" aria-hidden="true"></i>
      </button>
      <button type="button" mat-icon-button aria-label="Fechar notificações" (click)="close()">
        <i class="fa-solid fa-xmark" aria-hidden="true"></i>
      </button>
    </div>
  </header>

  <div class="mobile-navbar-dialog-results">
    <button
      type="button"
      class="mobile-notification-card"
      *ngFor="let notification of data.notifications"
      [class.mobile-notification-card--unread]="!notification.read"
      (click)="openNotification(notification)"
    >
      <div class="mobile-notification-card-header">
        <strong>{{ notification.title }}</strong>
        <i class="fa-solid fa-circle text-danger" *ngIf="!notification.read" aria-label="Não lida"></i>
      </div>
      <span>{{ getPreview(notification) }}</span>
    </button>

    <div class="mobile-navbar-dialog-status" *ngIf="data.notifications.length === 0">Nenhuma notificação encontrada.</div>
  </div>

  <button type="button" class="btn btn-outline-primary mobile-notifications-all" (click)="openAllNotifications()">
    Ver todas as notificações
  </button>
</section>
